<div x-expand-to-parent-bottom="" style="overflow-y: auto;" class="table-gauge">
    <table class="report-table table table-hover table-bordered table-condensed">
        <thead>
        <tr></tr>
        </thead>
        <tbody>
        </tbody>
    </table>
</div>